import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/videos/MASKOF.mp4'


const _hoisted_1 = {
  id: "mask-of",
  class: "lg:py-0"
}
const _hoisted_2 = { class: "container-default px-3 overflow-visible" }
const _hoisted_3 = { class: "relative grid grid-cols-1 lg:grid-cols-5" }
const _hoisted_4 = { class: "w-full lg:absolute lg:top-0 lg:right-0 lg:w-4/5 lg:h-full flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("video", {
  autoplay: "",
  playsinline: "",
  muted: "",
  loop: "",
  class: "w-full flex-1 object-contain bg-transparent"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "relative bg-gradient-to-bl from-neutral-900 via-neutral-900 to-black rounded-xl px-3 py-6 lg:px-6 space-y-6 col-start-1 col-span-2 z-10 lg:my-32" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-2" }, " About the first Foundation collection ")
], -1)
const _hoisted_9 = { class: "space-y-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "" }, " MASKOF is an animated 1/1 NFT collection showcasing a character avatar with unique masked outfits. With each NFT presenting its own story and aesthetic, it was sold out instantly, with two more NFTs completing the project. ", -1)
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" However, after MASKOF, ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" was started and demanded even greater effort and time. Maintaining the masked outfit aesthetic of MASKOF, ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" showcases a great variety of headwear, hairstyle, clothes, and jewelry traits, fitting all character avatars. ")
const _hoisted_15 = { class: "px-4" }

import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import AppPanel from "@/components/app/AppPanel.vue";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeMaskOf',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_animate = _resolveDirective("animate")!
  const _directive_parallax = _resolveDirective("parallax")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)), [
          [_directive_animate]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", _hoisted_11, [
              _hoisted_12,
              _createVNode(DripversityIcon, { class: "text-dripversity" }),
              _hoisted_13,
              _createVNode(DripversityIcon, { class: "text-dripversity" }),
              _hoisted_14
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(AppPanel, {
              title: "Explore MASKOF Collection",
              subtitle: "On Foundation",
              src: require('@/assets/images/maskof.gif'),
              size: "sm",
              href: "https://foundation.app/collection/maskof?sortOrder=DEFAULT"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_15, [
                  _createVNode(_unref(ChevronRightIcon), { class: "block w-3 text-neutral-200" })
                ])
              ]),
              _: 1
            }, 8, ["src"])
          ])
        ])), [
          [_directive_parallax, {
                        from: { yPercent: 25 },
                        to: { yPercent: -25 },
                    }],
          [
            _directive_animate,
            void 0,
            void 0,
            { stagger: true }
          ]
        ])
      ])
    ])
  ]))
}
}

})